import React, { useState, useEffect } from "react";
import { string, bool } from "prop-types";
import { SpeakerName } from "../../atoms/SpeakerName";
import { Designation } from "../../atoms/Designation";
import "./speaker-card.m.css";
import Confirmed from "../../../../assets/icons/confirmed";
import { Linked_In } from "../../../socialIcons/linked_in";
import placeholderImage from "../../../../../public/icons/placeholder_image.png";
import TeamMemberPopup from "../TeamMemberPopup";

const MOBILE_BREAKPOINT = 768;

export const SpeakerCard = ({ name, designation, company, imageUrl, isConfirmed = false, linkedIn, description, bio, disableBioPopup = false, type = "speaker" }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      if (typeof window !== 'undefined') {
        setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
      }
    };

    checkScreenSize();

    if (typeof window !== 'undefined') {
      window.addEventListener('resize', checkScreenSize);
      return () => window.removeEventListener('resize', checkScreenSize);
    }
  }, []);

  const finalImageUrl = imageUrl || placeholderImage;
  const handleCardClick = (e) => {
    // Check if the click target is the LinkedIn icon or its parent
    const linkedInElement = e.target.closest('a[href*="linkedin"]');
    if (linkedInElement) {
      return; // Don't open popup if LinkedIn link was clicked
    }

    if (!disableBioPopup) {
      setIsPopupOpen(true);
    }
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };

  // Prepare member data for the popup
  const memberData = {
    name,
    designation,
    company,
    image: imageUrl || placeholderImage,
    bio: bio || (description ? [{ text: description }] : [])
  };

  return (
    <>
      <div styleName={`speaker-card ${type === "participant" ? "participant" : ""}`} data-speaker-card onClick={handleCardClick} style={{ cursor: 'pointer' }}>
        {isMobile ? (
          /* Mobile Layout */
          <div styleName="mobile-layout">
            <div styleName="mobile-content">
              <div styleName="speaker-image">
                <img alt={name} src={finalImageUrl} />
              </div>
              <div styleName="bio-section">
                <div styleName="speaker-name-mobile">
                  {isConfirmed && (
                    <div styleName="confirmed-icon-mobile">
                      <Confirmed />
                    </div>
                  )}
                  <SpeakerName>{name}</SpeakerName>
                </div>
                <div styleName="designation-company-mobile">
                  {designation && <Designation>{designation}</Designation>}
                  {company && <Designation hasBorder>{company}</Designation>}
                </div>
              </div>
            </div>
            {linkedIn ? (
              <a href={linkedIn} target="_blank" rel="noopener noreferrer" styleName="linkedin-icon-mobile">
                <Linked_In />
              </a>
            ) : (
              <div styleName="linkedin-spacer"></div>
            )}
          </div>
        ) : (
          /* Desktop Layout */
          <div styleName="desktop-layout">
            <div styleName="image-and-name">
              <div styleName="image-and-linkedin">
                <div styleName="speaker-image">
                  <img alt={name} src={finalImageUrl} />
                </div>
                {linkedIn && (
                  <a href={linkedIn} target="_blank" rel="noopener noreferrer" styleName="linkedin-icon">
                    <Linked_In />
                  </a>
                )}
              </div>
              <div styleName="speaker-name-container">
                {isConfirmed && (
                  <div styleName="confirmed-icon-inline">
                    <Confirmed />
                  </div>
                )}
                <SpeakerName>{name}</SpeakerName>
              </div>
            </div>
            <div styleName="designation-company">
              {designation && <Designation>{designation}</Designation>}
              {company && <Designation hasBorder>{company}</Designation>}
            </div>
          </div>
        )}
      </div>

      <TeamMemberPopup
        member={memberData}
        isOpen={isPopupOpen}
        onClose={handleClosePopup}
        isMobile={isMobile}
      />
    </>
  );
};

SpeakerCard.propTypes = {
  name: string.isRequired,
  designation: string.isRequired,
  company: string,
  imageUrl: string,
  isConfirmed: bool,
  linkedIn: string,
  disableBioPopup: bool,
  type: string,
};